module.exports = "<div class=\"d-block text-center line-titles\">\n    <div class=\"circle firstData-title\"></div>\n    <span>{{ firstDataLabel }}</span>\n    <div class=\"circle secondData-title\"></div>\n    <span>{{ secondDataLabel }}</span>\n</div>\n<div class=\"d-block w-100 position-relative\" [class.w-print]=\"printing\" [style.height.px]=\"heightSize\">\n    <canvas [id]=\"element\"></canvas>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/charts/chart-line/chart-line.component.html
// module id = ./src/app/components/tools/charts/chart-line/chart-line.component.html
// module chunks = main